import {Timestamp} from "@firebase/firestore-types";

export type WordType = {
  word: string
  category: string
  createdAt?: Timestamp
  updatedAt?: Timestamp
  createdBy: string
  updatedBy: string
  isApproved: boolean
  hints: string[]
  isAutoGenerated: boolean
  isDeleted?: boolean
  cardName?: string
  lastUsed?: Timestamp
}

export const DEFAULT_WORD: WordType = {
  word: '',
  category: 'generic',
  createdBy: '',
  updatedBy: '',
  isApproved: true,
  hints: [],
  isAutoGenerated: false,
  isDeleted: false,
}

export type WordQueryType = Partial<{
  isApproved?: boolean,
  isDeleted?: boolean,
  word?: string,
  category?: string,
}>